module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-08-3ebfa23bfe7dab8ad7e5859b4ffa7141.png";